import React from "react";

import { FormattedMessage } from "react-intl";
import { Button } from "react-bootstrap";

function FilterPanelShowButton(props: { panelOpen: boolean; onClick: (e: React.SyntheticEvent<Button>) => void }) {
    const filterButtonTitle = props.panelOpen ? (
        <span>
            <i className="icon-lg icon-arrow-left" /> <FormattedMessage id="ORC_BUTTON_BACK" />
        </span>
    ) : (
        <span>
            <i className="icon-lg icon-filter hidden-xs" /> <FormattedMessage id="EX_FILTER_PANEL_OVERALL_CAPTION" />
        </span>
    );
    return (
        <Button onClick={props.onClick} className="ex-filter-panel-show-button">
            {filterButtonTitle}
        </Button>
    );
}

export default FilterPanelShowButton;
